import { render, staticRenderFns } from "./head-order-dialog.vue?vue&type=template&id=6faf23ca&"
import script from "./head-order-dialog.vue?vue&type=script&lang=js&"
export * from "./head-order-dialog.vue?vue&type=script&lang=js&"
import style0 from "./head-order-dialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "head-order-dialog.vue"
export default component.exports